import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: {
	/**
	 * labelタグのname属性。
	 */
	name: {
		type: String,
		required: false,
	},
	/**
	 * ラベル内容。
	 */
	text: {
		type: String,
		required: true,
	},
	/**
	 * 無効化状態かどうか。
	 */
	disabled: {
		type: Boolean,
		required: false,
		default: false,
	},
},
  setup(__props, { expose }) {
  expose()

const props = __props
/**
 * コミュニティトーク用のラベル表示。
 * UIを統一するため、labelタグを使用する場合はこちらのコンポーネントを使用してください。
 */

// NOTE: ここのみ他コンポーネントとPropsの定義方法が違う理由
// Propsのデフォルト値を設定するにはinterface形式ではできず、下記の形式の記述でないと出来ないため。
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef


const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})